export default __webpack_public_path__ + "img/dOviCkPB.ba7cda9a.svg";